export const cleanContent = (content, findAndReplace) => {
  switch (typeof content) {
    case 'string':
      return applyFindAndReplace(content, findAndReplace);
    case 'object':
      return cleanObject(content, findAndReplace);
    default:
      return content;
  }
};

const applyFindAndReplace = (content, findAndReplace) => {
  return findAndReplace.reduce((updatedContent, fr) => {
    return updatedContent.replace(fr.term, fr.replacement);
  }, content);
};

const cleanObject = (content, findAndReplace) => {
  return Object.keys(content).reduce((cleanedObj, key) => {
    const value = content[key];
    if (value) {
      if (Array.isArray(value)) {
        const cleanedArray = value.map((item) => cleanContent(item, findAndReplace));
        return { ...cleanedObj, [key]: cleanedArray };
      }
      const cleanedValue = cleanContent(value, findAndReplace);
      return { ...cleanedObj, [key]: cleanedValue };
    }
    return { ...cleanedObj, [key]: value };
  }, {});
};

export const c11nLink = (
  url: string,
  text: string,
  newTab: boolean = true,
  classes: string[] = [`c11n-link`, `c11n-link--secondary`],
) => `<a class="${classes.join(' ')}" href="${url}"${newTab ? ` target="_blank"` : ``}>${text}</a>`;
